interface Choix {
  choix1: string;
  choix2: string;
  choix3?: string;
  choix4?: string;
}

interface Question {
  id: number;
  statement: string;
  choix?: Choix;
  bonneReponse: string;
  reponseInfos?: string;
  reponsePlus?: string;
  contenuEtoile?: string[];
  contenuChoixEtoile?: string;
  questionContenuEtoile?: string[];
}

interface QuestionsParDifficulte {
  difficulte: number;
  questions: Question[];
}

interface QuestionTheme {
  theme: string;
  questionsParDifficulte: QuestionsParDifficulte[];
}

const questionsData: QuestionTheme[] = [
  {
    theme: `La maladie`,
    questionsParDifficulte: [
      {
        difficulte: 1,
        questions: [
          {
            id: 1,
            statement: `Une personne peut être atteinte d’hépatite C chronique sans ressentir de symptôme, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Vrai`,
            reponseInfos: `1`,
          },
          {
            id: 2,
            statement: `Il suffit d’une petite quantité de sang pour transmettre l’hépatite C, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Vrai`,
            reponseInfos: `2`,
          },
        ],
      },
      {
        difficulte: 2,
        questions: [
          {
            id: 1,
            statement: `Parmi les propositions suivantes, quelle étape du processus de dégradation du foie arrive en premier ?`,
            choix: { choix1: `La cirrhose`, choix2: `La fibrose` },
            bonneReponse: `La fibrose`,
            reponseInfos: `3`,
          },
          {
            id: 2,
            statement: `Parmi les propositions suivantes, quel facteur peut accélérer la dégradation des cellules du foie ?`,
            choix: {
              choix1: `La consommation d’alcool`,
              choix2: `Un régime sans viande`,
            },
            bonneReponse: `La consommation d’alcool`,
            reponseInfos: `3`,
          },
        ],
      },
      {
        difficulte: 3,
        questions: [
          {
            id: 1,
            statement: `Dans certains cas, l’hépatite C chronique peut, après plusieurs années d’évolution, évoluer vers un cancer du foie. Ce dernier est également appelé :`,
            choix: {
              choix1: `Carcinome hépato-cellulaire (CHC)`,
              choix2: `Mélanome`,
              choix3: `Lymphome`,
              choix4: `Sarcome`,
            },
            bonneReponse: `Carcinome hépato-cellulaire (CHC)`,
            reponseInfos: `3`,
          },
          {
            id: 2,
            statement: `Quel est l’organe principalement ciblé par le virus de l’hépatite C ?`,
            choix: {
              choix1: `Le cœur`,
              choix2: `Les poumons`,
              choix3: `Le foie`,
              choix4: `Le cerveau`,
            },
            bonneReponse: `Le foie`,
            reponseInfos: `4`,
          },
        ],
      },
      {
        difficulte: 4,
        questions: [
          {
            id: 1,
            statement: `À quel endroit du corps se situe le foie et quel est son poids moyen ?`,
            bonneReponse: `Dans la partie supérieure droite de l’abdomen, sous les côtes (montrer l’endroit suffit). Il pèse en moyenne 1,5 kg.`,
            reponseInfos: `5`,
          },
          {
            id: 2,
            statement: `Quels symptômes peuvent être dus à l’hépatite C ?`,
            bonneReponse: `Fatigue, dépression (voir d’autres exemples dans la section « Pour aller plus loin »).`,
            reponseInfos: `6`,
          },
        ],
      },
    ],
  },
  {
    theme: `Les modes de transmission`,
    questionsParDifficulte: [
      {
        difficulte: 1,
        questions: [
          {
            id: 1,
            statement: `Le virus de l’hépatite C peut être transmis par des objets de toilette piquants ou coupants contaminés (par exemple : rasoirs, brosse à dents, coupe-ongles, etc.), vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Vrai`,
            reponseInfos: `7,8`,
          },
          {
            id: 2,
            statement: `Il est possible de se faire contaminer par le virus de l’hépatite C lors de la réalisation d’un tatouage ou d’un piercing, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Vrai`,
            reponseInfos: `7,8`,
            reponsePlus: `Il est important de s'assurer que le matériel utilisé est stérile.`,
          },
        ],
      },
      {
        difficulte: 2,
        questions: [
          {
            id: 1,
            statement: `Partager du matériel de consommation de drogue intranasal (pailles, tubes etc.) peut transmettre l'hépatite C ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Vrai`,
            reponseInfos: `23`,

          },
          {
            id: 2,
            statement: `Le virus de l’hépatite C se transmet par contact avec :`,
            choix: { choix1: `La salive`, choix2: `Le sang` },
            bonneReponse: `Le sang`,
            reponseInfos: `7`,
          },
        ],
      },
      {
        difficulte: 3,
        questions: [
          {
            id: 1,
            statement: `De quel virus la PrEP* est-elle un moyen de prévention ?`,
            choix: {
              choix1: `Virus de l’immunodéficience humaine (VIH)`,
              choix2: `Virus de l’hépatite C`,
              choix3: `Virus de l’hépatite B`,
              choix4: `Virus de l’hépatite D`,
            },
            bonneReponse: `Virus de l’immunodéficience humaine (VIH)`,
            reponseInfos: `9`,
            questionContenuEtoile: [`* Prophylaxie pré-exposition`],
          },
          {
            id: 2,
            statement: `Le risque de transmission de l’hépatite C de la mère à l’enfant est de :`,
            choix: {
              choix1: `1 %`,
              choix2: `5 %`,
              choix3: `20 %`,
              choix4: `35 %`,
            },
            bonneReponse: `5 %`,
            reponseInfos: `7`,
          },
        ],
      },
      {
        difficulte: 4,
        questions: [
          {
            id: 1,
            statement: `Dans quelles conditions le virus de l’hépatite C peut-il être transmis pendant un rapport sexuel ?`,
            bonneReponse: `Si présence de sang (exemples : relations sexuelles pendant les règles, en présence de lésions).`,
            reponseInfos: `7`,
          },
          {
            id: 2,
            statement: `Quelles précautions prendre
                        en cas de consommation de drogues afin d’éviter
                        la contamination par le virus de l’hépatite C ?`,
            bonneReponse: `Par exemple, ne pas partager le matériel utilisé pour l’usage de drogues (seringue, cuillère, coton, paille pour inhalation, etc.).`,
            reponseInfos: `8`,
          },
        ],
      },
    ],
  },
  {
    theme: `La prise en charge`,
    questionsParDifficulte: [
      {
        difficulte: 1,
        questions: [
          {
            id: 1,
            statement: `L’hépatite C est la seule maladie virale chronique pouvant être guérie, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Vrai`,
            reponseInfos: `10`,
          },
          {
            id: 2,
            statement: `Les antiviraux à action directe (AAD) sont des médicaments utilisés par voie injectable, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Faux`,
            reponseInfos: `11`,
            reponsePlus: `Ils sont utilisés par voie orale.`,
          },
        ],
      },
      {
        difficulte: 2,
        questions: [
          {
            id: 1,
            statement: `Parmi les méthodes suivantes, laquelle permet d’évaluer la sévérité de l’atteinte du foie ?`,
            choix: { choix1: `L'élastométrie'`, choix2: `Le PET-scan` },
            bonneReponse: `L'élastométrie`,
            reponseInfos: `12`,
          },
          {
            id: 2,
            statement: `Les antiviraux à action directe (traitement de l’hépatite C chronique) nécessitent :`,
            choix: {
              choix1: `Une prise par jour`,
              choix2: `Plusieurs prises par jour`,
            },
            bonneReponse: `Une prise par jour`,
            reponseInfos: `11`,
          },
        ],
      },
      {
        difficulte: 3,
        questions: [
          {
            id: 1,
            statement: `Quels patients ayant une infection chronique par le virus de l’hépatite C peuvent être traités par antiviraux à action directe ?`,
            choix: {
              choix1: `Uniquement les patients contaminés après 1992`,
              choix2: `Tous les patients âgés de 3 ans et plus`,
              choix3: `Uniquement les patients de moins de 45 ans`,
              choix4: `Uniquement les patients ayant une cirrhose`,
            },
            bonneReponse: `Tous les patients âgés de 3 ans et plus`,
            reponseInfos: `11,13`,
          },
          {
            id: 2,
            statement: `Au cours des 30 dernières années, le traitement de l’hépatite C chronique a évolué dans le sens d' :`,
            choix: {
              choix1: `Une amélioration du profil de tolérance`,
              choix2: `Une diminution de l’efficacité`,
              choix3: `Une détérioration du profil de tolérance`,
              choix4: `Un allongement de la durée de traitement`,
            },
            bonneReponse: `Une amélioration du profil de tolérance`,
            reponseInfos: `14`,
          },
        ],
      },
      {
        difficulte: 4,
        questions: [
          {
            id: 1,
            statement: `Quelles sont les étapes de la prise en charge de l’hépatite C ?`,
            bonneReponse: `Chronologiquement : le dépistage puis, en cas de positivité, le bilan initial, le traitement et le suivi (Pour plus d’informations, se rendre dans la rubrique « Pour aller plus loin »).`,
            reponseInfos: `1`,
          },
          {
            id: 2,
            statement: `Avec qui peut-on parler d’un comportement à risque d’infection par le virus de l’hépatite C ?`,
            bonneReponse: `Tous les professionnels de santé ou personnels médico-sociaux (par exemple CSAPA*/ CAARUD**)`,
            reponseInfos: `22`,
            contenuEtoile: [
              `* Centre de Soins, d’Accompagnement et de Prévention en Addictologie`,
              `** Centre d’Accueil et d’Accompagnement à la Réduction des risques pour Usagers de Drogues`,
            ],
          },
        ],
      },
    ],
  },
  {
    theme: `Le dépistage`,
    questionsParDifficulte: [
      {
        difficulte: 1,
        questions: [
          {
            id: 1,
            statement: `Le TROD* hépatite C permet de détecter la présence d’anticorps anti-VHC** dans le sang, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Vrai`,
            reponseInfos: `15`,
            questionContenuEtoile: [
              `* Test Rapide d’Orientation Diagnostique`,
              `** Virus de l’hépatite C`,
            ],
          },
          {
            id: 2,
            statement: `Le dépistage de l’hépatite C est un geste obligatoirement douloureux, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Faux`,
            reponseInfos: `16,17`,
            reponsePlus:
              "Par exemple, le TROD* et le buvard sont des méthodes indolores.",
            contenuEtoile: [`* Test Rapide d’Orientation Diagnostique`],
          },
        ],
      },
      {
        difficulte: 2,
        questions: [
          {
            id: 1,
            statement: `Parmi les propositions suivantes, quelle est la conduite à tenir si le résultat du TROD* hépatite C est positif ?`,
            choix: {
              choix1: `Je dois faire une prise de sang pour confirmer la présence du virus.`,
              choix2: `Je n’ai rien à faire. Il est certain que je suis infecté par le virus de l’hépatite C.`,
            },
            bonneReponse: `Je dois faire une prise de sang pour confirmer la présence du virus.`,
            reponseInfos: `18`,
            questionContenuEtoile: [`* Test Rapide d’Orientation Diagnostique`],
          },
          {
            id: 2,
            statement: `Pour évaluer l’état du foie dans le cadre d’une prise en charge de l’hépatite C chronique :`,
            choix: {
              choix1: `Une biopsie hépatique est obligatoirement réalisée.`,
              choix2: `Des méthodes non invasives existent et peuvent être utilisées.`,
            },
            bonneReponse: `Des méthodes non invasives existent et peuvent être utilisées.`,
            reponseInfos: `19`,
          },
        ],
      },
      {
        difficulte: 3,
        questions: [
          {
            id: 1,
            statement: `Une personne est considérée à risque d’infection par le virus de l’hépatite C si elle a eu une transfusion avant :`,
            choix: {
              choix1: `1992`,
              choix2: `1995`,
              choix3: `1999`,
              choix4: `2002`,
            },
            bonneReponse: `1992`,
            reponseInfos: `18`,
          },
          {
            id: 2,
            statement: `Parmi les propositions suivantes, pour quel profil de patients le dépistage de l’hépatite C n’est pas spécifiquement recommandé ?`,
            choix: {
              choix1: `Une personne ayant été incarcérée`,
              choix2: `Un fumeur de tabac`,
              choix3: `Un usager de drogues`,
              choix4: `Une personne infectée par le VIH*`,
            },
            bonneReponse: `Un fumeur de tabac`,
            reponseInfos: `18`,
            contenuChoixEtoile: `* Virus de l’Immunodéficience Humaine`,
          },
        ],
      },
      {
        difficulte: 4,
        questions: [
          {
            id: 1,
            statement: `Quels virus peut-on dépister lors de la réalisation d’un buvard ?`,
            bonneReponse: `Par exemple, virus de l’hépatite C, virus de l’hépatite B, virus de l’immunodéficience humaine, etc.`,
            reponseInfos: `17`,
          },
          {
            id: 2,
            statement: `Quel est le but de la mesure de l'élastométrie du foie ?`,
            bonneReponse: `Évaluer la fibrose hépatique.`,
            reponseInfos: `12`,
          },
        ],
      },
    ],
  },
  {
    theme: `La guérison`,
    questionsParDifficulte: [
      {
        difficulte: 1,
        questions: [
          {
            id: 1,
            statement: `Une fois le traitement de l’hépatite C chronique terminé, on sait immédiatement que l’on est guéri, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Faux`,
            reponseInfos: `13`,
            reponsePlus: `Pour savoir si l’on est guéri, il est nécessaire de faire une recherche quantitative de l’ARN du VHC* 12 semaines après l’arrêt du traitement. Si l’ARN du VHC* est indétectable, on est guéri.`,
            contenuEtoile: [`* Acide RiboNucléique du Virus de l’Hépatite C`],
          },
          {
            id: 2,
            statement: `Un patient guéri de l’hépatite C peut voir l’état de son foie s’améliorer, vrai ou faux ?`,
            choix: { choix1: `Vrai`, choix2: `Faux` },
            bonneReponse: `Vrai`,
            reponseInfos: `13`,
            reponsePlus:
              "Dans certains cas, la fibrose du foie peut régresser.",
          },
        ],
      },
      {
        difficulte: 2,
        questions: [
          {
            id: 1,
            statement: `Un patient guéri de l’hépatite C :`,
            choix: {
              choix1: `Ne peut plus transmettre le virus.`,
              choix2: `Peut encore transmettre le virus.`,
            },
            bonneReponse: `Ne peut plus transmettre le virus.`,
            reponseInfos: `13`,
          },
          {
            id: 2,
            statement: `Parmi les propositions suivantes, la guérison de l’hépatite C chronique diminue le risque d’évolution vers :`,
            choix: {
              choix1: `Un cancer du foie`,
              choix2: `Une anorexie`,
            },
            bonneReponse: `Un cancer du foie`,
            reponseInfos: `20`,
          },
        ],
      },
      {
        difficulte: 3,
        questions: [
          {
            id: 1,
            statement: `Aujourd'hui, avec un traitement par AAD* pangénotypiques il est possible de guérir de l’hépatite C chronique dans\u00a0:`,
            choix: {
              choix1: `3 % des cas`,
              choix2: `50 % des cas`,
              choix3: `80 % des cas`,
              choix4: `Dans plus de 95 % des cas`,
            },
            bonneReponse: `Dans plus de 95 % des cas`,
            reponseInfos: `4`,
            questionContenuEtoile: [`* antiviraux à action directe`],
          },
          {
            id: 2,
            statement: `Combien de temps les anticorps anti-VHC* restent-ils détectables après guérison de l’hépatite C ?`,
            choix: {
              choix1: `3 jours`,
              choix2: `3 semaines`,
              choix3: `3 ans`,
              choix4: `Toute la vie`,
            },
            bonneReponse: `Toute la vie`,
            reponseInfos: `18`,
            questionContenuEtoile: [`* Virus de l’hépatite C`],
          },
        ],
      },
      {
        difficulte: 4,
        questions: [
          {
            id: 1,
            statement: `Est-il possible de se recontaminer par le virus de l’hépatite C après avoir été guéri ?`,
            bonneReponse: `Oui, les anticorps anti-VHC* ne sont pas protecteurs et il est possible de se recontaminer après guérison, en cas de conduites à risque (exemple : comportements sexuels à risque, usage de drogues avec partage de seringues, etc.).`,
            reponseInfos: `18`,
            contenuEtoile: [`* Virus de l’hépatite C`],
          },
          {
            id: 2,
            statement: `Quels impacts positifs peut avoir la guérison de l’hépatite C chronique ?`,
            bonneReponse: `Il est possible que la guérison de l’hépatite C chronique permette d’améliorer la dépression et la qualité de vie.`,
            reponseInfos: `21`,
          },
        ],
      },
    ],
  },
];

export { questionsData };
